
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/mailmagazine",
      function () {
        return require("private-next-pages/mailmagazine/index.tsx");
      }
    ]);
  